import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocaleProvider } from '@op/opds.opux';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const locale = (document.documentElement.getAttribute('lang') ?? 'fi')
  .substring(0, 2)
  .toLowerCase();


root.render(
  <React.StrictMode>
    <LocaleProvider locale={locale}>
      <App />
    </LocaleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();